import DOMPurify from "dompurify";
import { marked } from "marked";
import { useMemo } from "react";

/** Render user or lesson markdown safely (sanitized, so notes can never inject scripts). */
export function Markdown({ source }: { source: string }) {
  const html = useMemo(
    () => DOMPurify.sanitize(marked.parse(source, { async: false, breaks: true }) as string),
    [source],
  );
  return <div className="prose" dangerouslySetInnerHTML={{ __html: html }} />;
}
